import React, { FC, useEffect } from 'react';

const Footer: FC = () => {
    return <div id="soop-fnb" />;
};

export default Footer;
